import { Link } from 'react-router-dom';
import MangaCard from '@/components/feature/MangaCard';
import { mangaList, featuredMangaIds } from '@/mocks/manga';

export default function HotRecommend() {
  const featured = mangaList.filter((m) => featuredMangaIds.includes(m.id));

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-100">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">精选优质漫画，为你推荐最受欢迎的作品</p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-400 transition-colors flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            更多推荐
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
          {featured.slice(0, 3).map((manga) => (
            <MangaCard key={manga.id} manga={manga} variant="featured" />
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
          {featured.map((manga) => (
            <MangaCard key={manga.id} manga={manga} />
          ))}
        </div>
      </div>
    </section>
  );
}